module.exports = __webpack_public_path__ + "static/media/login-poster-2.31c6db99.jpg";